import axios from '../axios';

export const getProjectList = async (query: string, page: number) => {
  try {
    const endPoint = `api/root/project-list?query=${encodeURIComponent(query)}&page=${page}`;
    const res = await axios.get<Array<any>>(endPoint);
    if (!res?.data) throw new Error('Something went wrong');
    return res.data;
  } catch (err: any) {
    return Promise.reject(err);
  }
};

export const getProjectById = async (id: number) => {
  try {
    const endPoint = `api/root/project/${id}/`;
    const res = await axios.get<Array<any>>(endPoint);
    if (!res?.data) throw new Error('Something went wrong');
    return res.data;
  } catch (err: any) {
    return Promise.reject(err);
  }
};

export const getProjectById1 = async (id: number) => {
  try {
    const endPoint = `api/root/project-info-by-id/`;
    const res = await axios.post<Array<any>>(
      endPoint,
      { project_id: id },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
    if (!res?.data) throw new Error('Something went wrong');
    return res.data;
  } catch (err: any) {
    console.error('Error:', err.response ? err.response.data : err.message);
    return Promise.reject(err);
  }
};
